export const ROUTE_PATHS = Object.freeze({
    about: '/main/about',
    downloadTransfer: '/download/transfer',
    downloadFile: '/download/file',
    RecipeResultPage: '/recipe/RecipeResultPage',
    PersonalVIP: '/personal/vip',
    personalOrder: '/personal/order',
    MemberAgreement: '/member/agreement',
    ReportResult: '/report/result',
    PrivacyPolicy: '/personal/PrivacyPolicy',
    UserAgreement: '/personal/UserAgreement',
    ConversationKetogenicDiet: '/conversation/ketogenicDiet',
    ConversationNutritionAssessment: '/conversation/nutritionAssessment',
    ConversationRecipeCustomization: '/conversation/recipeCustomization',
    ConversationSportNutrition: '/conversation/sportNutrition',
    RecipeHistory: '/custom/RecipeHistory',
});